// Generated by GitHub Copilot
import React from "react";
import PropTypes from "prop-types";
import { FaFlask } from "react-icons/fa";
import styles from "./FeatureToggle.module.css";

/**
 * Feature Toggle Component with descriptions and experimental indicators
 */
const FeatureToggle = ({ feature, enabled, onChange, disabled = false }) => {
  /**
   * Get feature icon based on type
   */
  const getFeatureIcon = () => {
    if (feature.experimental) {
      return <FaFlask className={styles.badgeIcon} />;
    }
    return null;
  };

  /**
   * Handle toggle change
   */
  const handleChange = (event) => {
    onChange(feature.name, event.target.checked);
  };

  return (
    <div
      className={`${styles.toggleContainer} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <div className={styles.toggleSwitch}>
        <input
          type="checkbox"
          id={`feature-${feature.name}`}
          checked={enabled}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>

      <div className={styles.toggleContent}>
        <div className={styles.toggleHeader}>
          <div className={styles.toggleTitle}>{feature.displayName}</div>

          {(feature.experimental || feature.beta) && (
            <span
              className={`${styles.badge} ${
                feature.experimental
                  ? styles.badgeExperimental
                  : styles.badgeBeta
              }`}
            >
              {getFeatureIcon()}
              {feature.experimental ? "Experimental" : "Beta"}
            </span>
          )}
        </div>

        <div className={styles.toggleDescription}>{feature.description}</div>

        {feature.rolloutPercentage && feature.rolloutPercentage < 100 && (
          <div className={styles.rolloutText}>
            Limited rollout: {feature.rolloutPercentage}% of users
          </div>
        )}

        {feature.dependencies && feature.dependencies.length > 0 && (
          <div className={styles.dependenciesText}>
            Requires: {feature.dependencies.join(", ")}
          </div>
        )}
      </div>

      {disabled && (
        <div className={styles.restrictionText}>Disabled</div>
      )}
    </div>
  );
};

FeatureToggle.propTypes = {
  feature: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    status: PropTypes.string
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default FeatureToggle;
